
import { defineComponent, SetupContext, ref } from "vue";
import NativeClient from "@/client/native-client";
import { FoodTipData } from "@/types/pantry";

export default defineComponent({
  name: "PantryFoodTipTitle",
  components: {
  },
  props: {
    data: {
      type: FoodTipData,
      default: null
    },
    selectId: {
      type: Number,
      default: 0,
      require: true
    }
  },
  setup(props, context: SetupContext) {
    const getText = () => {
      let result = "";
      if (props.data && props.data.tip && props.data.tip.description) {
        result = props.data.tip.description;
      }
      return result;
    };
    const isActive = () => {
      return (props.data && props.data.id == props.selectId);
    };
    const getDisplay = () => {
      return isActive() ? "flex" : "none";
    }
    return {
      getText,
      getDisplay
    };
  }
});
